<template>
  <section class="block-cta cta">
    <div class="container">
      <div class="cta__body">
        <h3 class="cta__title" v-if="device_platform === 'mobile'">
          успейте купить<br />
          абонемент со скидкой
        </h3>
        <div class="cta__img-container">
          <img
            src="../images/bg/bg-clock.webp"
            alt="ФитнесМания"
            class="cta__img"
          />
        </div>

        <div class="cta__content">
          <h3 class="cta__title" v-if="device_platform !== 'mobile'">
            успейте купить<br />
            абонемент со скидкой
          </h3>
          <div class="cta__form">
            <callback-input
              :data="{ type: 'sale', form: 'cta' }"
              v-on="$listeners"
            >
              Забронировать абонемент
            </callback-input>
          </div>

          <clock></clock>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Clock from "./clock";
import CallbackInput from "./callback-form/callback-input";

import Mixin from "../common/mixin";

export default {
  name: "block-cta",
  mixins: [Mixin],
  components: { Clock, CallbackInput },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.cta {
  padding: 80px 0;

  &__body {
    background-color: $transparent;
    display: flex;
    align-items: center;
    padding-top: 48px;
    padding-bottom: 41px;
  }

  &__img-container {
    transform: translateY(-16px);
    max-width: 807px;
  }

  &__img {
    max-width: 100%;
  }

  &__content {
    flex: 1;
    padding-left: 35px;
  }

  &__form {
    max-width: 316px;
    margin: 32px 0 34px 0;
  }

  &__title {
    font-family: "Bebas Neue", sans-serif;
    font-size: 30px;
    font-weight: 700;
    text-transform: uppercase;
    color: $almost-gray;
    letter-spacing: 0.05em;
  }
}

@media (max-width: 800px) {
  .cta {
    padding: 40px 0;
    &__body {
      padding-top: 32px;
      padding-bottom: 32px;
    }

    &__form {
      margin: 8px 0 24px 0;
    }

    &__title {
      font-size: 24px;
    }
  }
}

@media (max-width: 640px) {
  .cta {
    padding: 32px 0;
    &__body {
      flex-direction: column;
      padding-right: 19px;
      padding-left: 19px;
    }

    &__content {
      padding-right: 0;
    }

    &__title {
      text-align: center;
    }
  }
}
</style>
